module.exports = __webpack_public_path__ + "img/coffee-beans.bb55c3e7.svg";